export default "__VITE_ASSET__d5SQm9py__"